/* Logic réfléchie avec AI */

export default class Cursor{
    constructor(element){
        this.element = element;
        this.cursor = document.querySelector('.cursor');

        this.init();
    }

    init(){
        console.log("allo");

        document.addEventListener('mousemove', (e) => {
            this.cursor.style.left = e.clientX + 'px';
            this.cursor.style.top  = e.clientY + 'px';
        });


        const watchs = document.querySelectorAll('[data-interactive]');
        for (let i = 0; i < watchs.length; i++) {
            const watch = watchs[i];
            watch.addEventListener('mouseenter', this.addActive.bind(this));
            watch.addEventListener('mouseleave', this.removeActive.bind(this));
        }

    }

    addActive(){
        console.log("je suis gros");
        this.cursor.classList.add('is-active');
    }

    removeActive(){
        console.log("je suis petit");
        this.cursor.classList.remove('is-active');
    }
}